import Enumerator from '../global/Enumerator';

export const insuranceTypes = [
  'home_and_contents',
  'vehicle',
  'private_health',
  'TPD_provider',
  'life_provider',
  'income_protection',
  'trauma',
  'loan_protection',
  'gap',
  'motor_warranty_products',
  'other'
];

export class InsuranceType extends Enumerator {
  static default() {
    return this.of('home_and_contents');
  }
}

InsuranceType.initEnum({
  home_and_contents: {
    get id() {
      return 'home_and_contents';
    },
    get title() {
      return 'Home and contents';
    },
    get weight() {
      return 1;
    }
  },
  vehicle: {
    get id() {
      return 'vehicle';
    },
    get title() {
      return 'Vehicle';
    },
    get weight() {
      return 2;
    }
  },
  private_health: {
    get id() {
      return 'private_health';
    },
    get title() {
      return 'Private health';
    },
    get weight() {
      return 3;
    }
  },
  TPD_provider: {
    get id() {
      return 'TPD_provider';
    },
    get title() {
      return 'TPD provider';
    },
    get weight() {
      return 4;
    }
  },
  life_provider: {
    get id() {
      return 'life_provider';
    },
    get title() {
      return 'Life provider';
    },
    get weight() {
      return 5;
    }
  },
  income_protection: {
    get id() {
      return 'income_protection';
    },
    get title() {
      return 'Income protection';
    },
    get weight() {
      return 6;
    }
  },
  trauma: {
    get id() {
      return 'trauma';
    },
    get title() {
      return 'Trauma';
    },
    get weight() {
      return 7;
    }
  },
  loan_protection: {
    get id() {
      return 'loan_protection';
    },
    get title() {
      return 'Loan protection';
    },
    get weight() {
      return 8;
    }
  },
  gap: {
    get id() {
      return 'gap';
    },
    get title() {
      return 'Gap';
    },
    get weight() {
      return 9;
    }
  },
  motor_warranty_products: {
    get id() {
      return 'motor_warranty_products';
    },
    get title() {
      return 'Motor warranty products';
    },
    get weight() {
      return 10;
    }
  },
  other: {
    get id() {
      return 'other';
    },
    get title() {
      return 'Other';
    },
    get weight() {
      return 11;
    }
  }
});

export default {
  insuranceTypes,
  InsuranceType
};
